module.exports = __webpack_public_path__ + "51de4bcaa69c25d9a137329b914f4d44.png";


//////////////////
// WEBPACK FOOTER
// ./src/act/march_promotion/img/lipstick.png
// module id = 280
// module chunks = 0